let userList = {
    code: 200,
    message: 'success',
    data: {
        total: 100,
        'hitsList': [
            {
                'yesterdaytext': '昨日点击量',
                'yesterdaynum': '538',
                'beforetext': '前日点击量',
                'percentage': '27.79%',
                'beforenum': '421',
                "trend": 0,
            },
        ]
    }
}
let hits = {
    code: 200,
    message: 'success',
    'hitsList': [
        {
            'yesterdaytext': '昨日点击量',
            'yesterdaynum': '6,994',
            'beforetext': '前日点击量',
            'percentage': '27.79%',
            'beforenum': '5,473',
            "trend": 0,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本周点击量',
            'yesterdaynum': '56,108',
            'beforetext': '上周点击量',
            'percentage': '15.25%',
            'beforenum': '4,868.5',
            "trend": 0,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本月点击量',
            'yesterdaynum': '126,230',
            'beforetext': '上月点击量',
            'percentage': '39.59%',
            'beforenum': '2,089.62',
            "trend": 1,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '今年点击量',
            'yesterdaynum': '1,182,415',
            'beforetext': '去年点击量',
            'percentage': '12.82%',
            'beforenum': '1,356,225',
            "trend": 1,
            "jstext":"同比计算"
        },
    ],
    'distribution': [
        {
            'yesterdaytext': '昨日分销金额',
            'yesterdaynum': '38,324',
            'beforetext': '前日分销金额',
            'percentage': '210.64%',
            'beforenum': '12,337',
            "trend": 0,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本周分销金额',
            'yesterdaynum': '220,933.7',
            'beforetext': '上周分销金额',
            'percentage': '36.39%',
            'beforenum': '3,473.21',
            "trend": 1,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本月分销金额',
            'yesterdaynum': '1,607,145.8',
            'beforetext': '上月分销金额',
            'percentage': '42.48%',
            'beforenum': '2,794,256.4',
            "trend": 1,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '今年分销金额',
            'yesterdaynum': '21,363,450.16',
            'beforetext': '去年分销金额',
            'percentage': '4.10%',
            'beforenum': '20,521,779.46',
            "trend": 0,
            "jstext":"同比计算"
        },

    ],
    'issue': [
        {
            'yesterdaytext': '昨日出单量',
            'yesterdaynum': '26',
            'beforetext': '前日出单量',
            'percentage': '100.00%',
            'beforenum': '13',
            "trend": 0,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本周出单量',
            'yesterdaynum': '195',
            'beforetext': '上周出单量',
            'percentage': '48.28%',
            'beforenum': '377',
            "trend": 1,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '本月出单量',
            'yesterdaynum': '1248',
            'beforetext': '上月出单量',
            'percentage': '44.83%',
            'beforenum': '2262',
            "trend": 1,
            "jstext":"环比计算"
        },
        {
            'yesterdaytext': '今年出单量',
            'yesterdaynum': '17,056',
            'beforetext': '去年出单量',
            'percentage': '10.32%',
            'beforenum': '19,019',
            "trend": 1,
            "jstext":"同比计算"
        },

    ]

}
let bulletin = {
    code: 200,
    message: 'success',
    data: [
        {
            'time': ["2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["14584", "31411", "9857", "23233", "7525", "21424", "6786"],
            "AvantLinkzz": ["10", "16", "6", "12", "5", "15", "4"],
            "ShareASaleje": ["9748", "24134", "11965", "14523", "4812", "16900","8538"],
            "ShareASaleds": ["7", "12", "9", "7", "3", "11", "6"],
        },
        {

            "time": ["2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25",
                "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["4710.9", "4205", "1449", "1954", "2097", "1499", "949", "2987", "0", "1419", "0", "1869", "0", "6344.9", "1918", "1499", "4096", "4096", "0", "2838", "0", "0", "0","14584", "31411", "9857", "23233", "7525", "21424", "6786"],
            "AvantLinkzz": ["3", "4", "1", "1", "2", "1", "1", "2", "0", "1", "0", "1", "0", "5", "2", "1", "3", "3", "0", "2", "0", "0", "0", "10", "16", "6", "12", "5", "15", "4"],
            "ShareASaleje": ["3612", "1307", "1499", "3412.9", "3447", "4437", "2338", "6275", "1949", "4367", "2898", "1869", "1869", "4317", "919", "2498", "1869", "1869", "919", "6236", "1598", "1598", "1598", "9748", "24134", "11965", "14523", "4812", "16900","8538"],
            "ShareASaleds": ["4", "2", "1", "3", "2", "3", "2", "4", "1", "3", "2", "1", "1", "3", "1", "2", "1", "1", "1", "4", "2", "2", "2","7", "12", "9", "7", "3", "11", "6"]
        },
        {
            "time": ["2022/6/4", "2022/6/5", "2022/6/6", "2022/6/7", "2022/6/8", "2022/6/9", "2022/6/10", "2022/6/11", "2022/6/12", "2022/6/13", "2022/6/14", "2022/6/15", "2022/6/16", "2022/6/17", "2022/6/18", "2022/6/19", "2022/6/20", "2022/6/21", "2022/6/22", "2022/6/23", "2022/6/24", "2022/6/25", "2022/6/26", "2022/6/27", "2022/6/28", "2022/6/29", "2022/6/30", "2022/7/1", "2022/7/2", "2022/7/3", "2022/7/4", "2022/7/5", "2022/7/6", "2022/7/7", "2022/7/8", "2022/7/9", "2022/7/10", "2022/7/11", "2022/7/12", "2022/7/13", "2022/7/14", "2022/7/15", "2022/7/16", "2022/7/17", "2022/7/18", "2022/7/19", "2022/7/20", "2022/7/21", "2022/7/22", "2022/7/23", "2022/7/24", "2022/7/25", "2022/7/26", "2022/7/27", "2022/7/28", "2022/7/29", "2022/7/30", "2022/7/31", "2022/8/1", "2022/8/2", "2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25", "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["1499", "3996", "4153", "4026", "5283", "972.9", "2398", "7573", "2977", "5224", "1948", "1419", "9084", "4892.8", "1997", "2948", "1899", "3496", "4840.9", "4797", "5010", "1677", "0", "5025", "0", "1499", "3288", "2671", "40", "919", "1419", "2497", "949", "3817", "2848", "3696", "1856", "3867", "1578", "0", "7245", "0", "0", "7142", "919", "9312", "1749", "3486", "1419", "3387", "1419", "99", "129", "3569.9", "1449", "6186", "1419", "1899", "0", "0", "4710.9", "4205", "1449", "1954", "2097", "1499", "949", "2987", "0", "1419", "0", "1869", "0", "6344.9", "1918", "1499", "4096", "4096", "0", "2838", "0", "0", "0","14584", "31411", "9857", "23233", "7525", "21424", "6786"],
            "AvantLinkzz": ["1", "3", "3", "3", "4", "1", "2", "6", "2", "4", "1", "1", "6", "6", "2", "2", "1", "3", "3", "3", "5", "1", "0", "3", "0", "1", "2", "3", "1", "1", "1", "3", "1", "3", "2", "4", "2", "2", "2", "0", "5", "0", "0", "6", "1", "7", "3", "4", "1", "2", "1", "1", "1", "2", "1", "4", "1", "1", "0", "0", "3", "4", "1", "1", "2", "1", "1", "2", "0", "1", "0", "1", "0", "5", "2", "1", "3", "3", "0", "2", "0", "0", "0", "10", "16", "6", "12", "5", "15", "4"],
            "ShareASaleje": ["4126", "2547", "4982", "4598.9", "6394", "1899", "3397", "8353", "3705", "9542", "10942", "5995", "13181", "9106.9", "6095", "6524", "10157.9", "7762", "9213", "5136.2", "7813.2", "7573.2", "3096", "11970", "1698", "2517", "8864", "1968", "2488", "3367", "3387", "9029", "7345", "2818", "7523", "3474", "4255", "5964", "4996", "2977", "6024", "99", "4646", "4916", "2948", "6314", "4625", "8693", "2028", "4867", "4707", "3917", "1419", "2338", "4724", "9286.9", "3165", "5347", "5888", "3867", "3612", "1307", "1499", "3412.9", "3447", "4437", "2338", "6275", "1949", "4367", "2898", "1869", "1869", "4317", "919", "2498", "1869", "1869", "919", "6236", "1598", "1598", "1598", "9748", "24134", "11965", "14523", "4812", "16900","8538"],
            "ShareASaleds": ["3", "3", "4", "4", "6", "1", "3", "5", "3", "6", "8", "4", "8", "7", "5", "5", "7", "6", "7", "5", "8", "6", "3", "8", "2", "3", "6", "3", "3", "3", "2", "7", "6", "2", "6", "6", "3", "5", "4", "2", "5", "1", "4", "3", "2", "7", "4", "7", "2", "3", "3", "2", "1", "2", "4", "5", "4", "3", "5", "3", "4", "2", "1", "3", "2", "3", "2", "4", "1", "3", "2", "1", "1", "3", "1", "2", "1", "1", "1", "4", "2", "2", "2", "7", "12", "9", "7", "3", "11", "6"]
        },
        {
            "time": ["2021/9/2", "2021/9/3", "2021/9/4", "2021/9/5", "2021/9/6", "2021/9/7", "2021/9/8", "2021/9/9", "2021/9/10", "2021/9/11", "2021/9/12", "2021/9/13", "2021/9/14", "2021/9/15", "2021/9/16", "2021/9/17", "2021/9/18", "2021/9/19", "2021/9/20", "2021/9/21", "2021/9/22", "2021/9/23", "2021/9/24", "2021/9/25", "2021/9/26", "2021/9/27", "2021/9/28", "2021/9/29", "2021/9/30", "2021/10/1", "2021/10/2", "2021/10/3", "2021/10/4", "2021/10/5", "2021/10/6", "2021/10/7", "2021/10/8", "2021/10/9", "2021/10/10", "2021/10/11", "2021/10/12", "2021/10/13", "2021/10/14", "2021/10/15", "2021/10/16", "2021/10/17", "2021/10/18", "2021/10/19", "2021/10/20", "2021/10/21", "2021/10/22", "2021/10/23", "2021/10/24", "2021/10/25", "2021/10/26", "2021/10/27", "2021/10/28", "2021/10/29", "2021/10/30", "2021/10/31", "2021/11/1", "2021/11/2", "2021/11/3", "2021/11/4", "2021/11/5", "2021/11/6", "2021/11/7", "2021/11/8", "2021/11/9", "2021/11/10", "2021/11/11", "2021/11/12", "2021/11/13", "2021/11/14", "2021/11/15", "2021/11/16", "2021/11/17", "2021/11/18", "2021/11/19", "2021/11/20", "2021/11/21", "2021/11/22", "2021/11/23", "2021/11/24", "2021/11/25", "2021/11/26", "2021/11/27", "2021/11/28", "2021/11/29", "2021/11/30", "2021/12/1", "2021/12/2", "2021/12/3", "2021/12/4", "2021/12/5", "2021/12/6", "2021/12/7", "2021/12/8", "2021/12/9", "2021/12/10", "2021/12/11", "2021/12/12", "2021/12/13", "2021/12/14", "2021/12/15", "2021/12/16", "2021/12/17", "2021/12/18", "2021/12/19", "2021/12/20", "2021/12/21", "2021/12/22", "2021/12/23", "2021/12/24", "2021/12/25", "2021/12/26", "2021/12/27", "2021/12/28", "2021/12/29", "2021/12/30", "2021/12/31", "2022/1/1", "2022/1/2", "2022/1/3", "2022/1/4", "2022/1/5", "2022/1/6", "2022/1/7", "2022/1/8", "2022/1/9", "2022/1/10", "2022/1/11", "2022/1/12", "2022/1/13", "2022/1/14", "2022/1/15", "2022/1/16", "2022/1/17", "2022/1/18", "2022/1/19", "2022/1/20", "2022/1/21", "2022/1/22", "2022/1/23", "2022/1/24", "2022/1/25", "2022/1/26", "2022/1/27", "2022/1/28", "2022/1/29", "2022/1/30", "2022/1/31", "2022/2/1", "2022/2/2", "2022/2/3", "2022/2/4", "2022/2/5", "2022/2/6", "2022/2/7", "2022/2/8", "2022/2/9", "2022/2/10", "2022/2/11", "2022/2/12", "2022/2/13", "2022/2/14", "2022/2/15", "2022/2/16", "2022/2/17", "2022/2/18", "2022/2/19", "2022/2/20", "2022/2/21", "2022/2/22", "2022/2/23", "2022/2/24", "2022/2/25", "2022/2/26", "2022/2/27", "2022/2/28", "2022/3/1", "2022/3/2", "2022/3/3", "2022/3/4", "2022/3/5", "2022/3/6", "2022/3/7", "2022/3/8", "2022/3/9", "2022/3/10", "2022/3/11", "2022/3/12", "2022/3/13", "2022/3/14", "2022/3/15", "2022/3/16", "2022/3/17", "2022/3/18", "2022/3/19", "2022/3/20", "2022/3/21", "2022/3/22", "2022/3/23", "2022/3/24", "2022/3/25", "2022/3/26", "2022/3/27", "2022/3/28", "2022/3/29", "2022/3/30", "2022/3/31", "2022/4/1", "2022/4/2", "2022/4/3", "2022/4/4", "2022/4/5", "2022/4/6", "2022/4/7", "2022/4/8", "2022/4/9", "2022/4/10", "2022/4/11", "2022/4/12", "2022/4/13", "2022/4/14", "2022/4/15", "2022/4/16", "2022/4/17", "2022/4/18", "2022/4/19", "2022/4/20", "2022/4/21", "2022/4/22", "2022/4/23", "2022/4/24", "2022/4/25", "2022/4/26", "2022/4/27", "2022/4/28", "2022/4/29", "2022/4/30", "2022/5/1", "2022/5/2", "2022/5/3", "2022/5/4", "2022/5/5", "2022/5/6", "2022/5/7", "2022/5/8", "2022/5/9", "2022/5/10", "2022/5/11", "2022/5/12", "2022/5/13", "2022/5/14", "2022/5/15", "2022/5/16", "2022/5/17", "2022/5/18", "2022/5/19", "2022/5/20", "2022/5/21", "2022/5/22", "2022/5/23", "2022/5/24", "2022/5/25", "2022/5/26", "2022/5/27", "2022/5/28", "2022/5/29", "2022/5/30", "2022/5/31", "2022/6/1", "2022/6/2", "2022/6/3", "2022/6/4", "2022/6/5", "2022/6/6", "2022/6/7", "2022/6/8", "2022/6/9", "2022/6/10", "2022/6/11", "2022/6/12", "2022/6/13", "2022/6/14", "2022/6/15", "2022/6/16", "2022/6/17", "2022/6/18", "2022/6/19", "2022/6/20", "2022/6/21", "2022/6/22", "2022/6/23", "2022/6/24", "2022/6/25", "2022/6/26", "2022/6/27", "2022/6/28", "2022/6/29", "2022/6/30", "2022/7/1", "2022/7/2", "2022/7/3", "2022/7/4", "2022/7/5", "2022/7/6", "2022/7/7", "2022/7/8", "2022/7/9", "2022/7/10", "2022/7/11", "2022/7/12", "2022/7/13", "2022/7/14", "2022/7/15", "2022/7/16", "2022/7/17", "2022/7/18", "2022/7/19", "2022/7/20", "2022/7/21", "2022/7/22", "2022/7/23", "2022/7/24", "2022/7/25", "2022/7/26", "2022/7/27", "2022/7/28", "2022/7/29", "2022/7/30", "2022/7/31", "2022/8/1", "2022/8/2", "2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25", "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "20229/1"],
            "AvantLinkzxje": ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "3098", "49", "49", "49", "49", "49", "49", "1349", "1349", "1349", "1349", "474", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "1947", "50", "50", "50", "50", "50", "50", "1399", "1399", "50", "100", "100", "9681", "2847", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1399", "1399", "179", "179", "0", "0", "0", "0", "99", "1048", "1048", "1048", "1048", "1048", "1048", "1048", "949", "949", "949", "949", "949", "1399", "1399", "1399", "1399", "1399", "1749", "1749", "0", "1399", "1399", "1399", "0", "0", "0", "0", "0", "899", "899", "1799", "0", "1424", "98", "98", "1399", "129", "0", "0", "0", "0", "0", "0", "0", "0", "1399", "1399", "1399", "0", "4446", "2475", "2475", "2475", "2475", "258", "1700.9", "4493", "5451.99", "0", "3347", "2101.9", "2101.9", "949", "2028", "0", "949", "2398", "2947", "3348", "3348", "3348", "3000.9", "20", "2998", "1899", "2648", "3027", "1449", "0", "0", "3448", "1987.8", "4696.4", "4297", "3077", "4347", "949", "3448", "3348", "4426", "1449", "0", "3156", "5720.9", "2898", "1899", "5396", "8745", "5426", "1899", "23.9", "4602.8", "2848", "997", "3500.9", "3206", "258", "2871.9", "1925", "0", "1449", "5886", "0", "10293", "1499", "0", "4847", "2948", "8876.9", "1548", "3996", "6746", "3894.8", "1806.9", "5395", "4846", "2997", "4284", "1449", "3146", "5395", "3798", "5306", "13719", "5555", "3755", "3576", "1899", "2870.9", "1548", "2398", "5974", "1548", "3946.1", "6812.8", "1499", "1499", "3996", "4153", "4026", "5283", "972.9", "2398", "7573", "2977", "5224", "1948", "1419", "9084", "4892.8", "1997", "2948", "1899", "3496", "4840.9", "4797", "5010", "1677", "0", "5025", "0", "1499", "3288", "2671", "40", "919", "1419", "2497", "949", "3817", "2848", "3696", "1856", "3867", "1578", "0", "7245", "0", "0", "7142", "919", "9312", "1749", "3486", "1419", "3387", "1419", "99", "129", "3569.9", "1449", "6186", "1419", "1899", "0", "0", "4710.9", "4205", "1449", "1954", "2097", "1499", "949", "2987", "0", "1419", "0", "1869", "0", "6344.9", "1918", "1499", "4096", "4096", "0", "2838", "0", "0", "0","14584", "31411", "9857", "23233", "7525", "21424", "6786"],
            "AvantLinkzz": ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "2", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "9", "3", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1", "1", "1", "0", "0", "0", "0", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "0", "1", "1", "1", "0", "0", "0", "0", "0", "1", "1", "1", "0", "2", "1", "1", "1", "1", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1", "1", "0", "3", "2", "2", "2", "2", "1", "2", "2", "3", "0", "2", "2", "2", "1", "1", "0", "1", "2", "3", "2", "2", "2", "3", "1", "2", "1", "1", "2", "1", "0", "0", "2", "2", "3", "3", "2", "3", "1", "2", "2", "4", "1", "0", "4", "3", "2", "1", "4", "5", "3", "1", "1", "5", "2", "1", "3", "3", "2", "3", "5", "0", "1", "4", "0", "7", "1", "0", "3", "2", "5", "2", "4", "4", "3", "2", "4", "4", "2", "6", "1", "3", "5", "2", "4", "10", "4", "3", "2", "1", "3", "2", "2", "6", "2", "3", "5", "1", "1", "3", "3", "3", "4", "1", "2", "6", "2", "4", "1", "1", "6", "6", "2", "2", "1", "3", "3", "3", "5", "1", "0", "3", "0", "1", "2", "3", "1", "1", "1", "3", "1", "3", "2", "4", "2", "2", "2", "0", "5", "0", "0", "6", "1", "7", "3", "4", "1", "2", "1", "1", "1", "2", "1", "4", "1", "1", "0", "0", "3", "4", "1", "1", "2", "1", "1", "2", "0", "1", "0", "1", "0", "5", "2", "1", "3", "3", "0", "2", "0", "0", "0", "10", "16", "6", "12", "5", "15", "4"],
            "ShareASaleje": ["4597", "949", "949", "1399", "998", "998", "3997", "1399", "1399", "1399", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "2798", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "6994", "1799", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1399", "1799", "1799", "1799", "1799", "1799", "1799", "1799", "99", "99", "99", "99", "99", "2056.89", "2056.89", "2056.89", "2056.89", "2056.89", "2056.89", "99", "99", "99", "99", "99", "0", "0", "1349", "1349", "949", "949", "949", "949", "99", "1048", "1048", "1048", "1048", "1048", "1048", "1048", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1500.99", "1799", "1799", "1799", "1799", "1799", "1799", "1399", "1399", "899", "0", "1799", "1048", "1399", "949", "949", "0", "0", "1399", "1399", "949", "1799", "1799", "3247", "3247", "949", "0", "1399", "1399", "2748", "3148", "4274", "4274", "4274", "4274", "486", "1700.9", "3484", "1949", "2518", "1398", "72.9", "72.9", "0", "1949", "2207", "999", "1499", "1504.9", "4847", "4847", "4847", "1151.9", "1499", "0", "1449", "4375", "1898", "5415", "3027", "3027", "3577", "0", "2926.4", "2618.4", "3068.4", "5575", "949", "1499", "4870.9", "19.9", "1949", "949", "3285", "3798", "8421.8", "2627", "3047", "7104", "2948", "5525", "2471.9", "5099.9", "5925", "999", "6845", "2498", "7067.9", "2897", "5575", "3547", "2498", "3927", "1949", "5496", "1499", "4347", "1899", "5896", "13402.9", "5968.9", "6879.8", "2898", "8169.8", "7830", "0", "3397", "15908", "11122", "196.8", "6493", "7923", "1648", "7559", "4667", "9373", "5075", "999", "9645", "4945", "5495", "3497", "4148.9", "8210", "7593", "3146", "4126", "4126", "2547", "4982", "4598.9", "6394", "1899", "3397", "8353", "3705", "9542", "10942", "5995", "13181", "9106.9", "6095", "6524", "10157.9", "7762", "9213", "5136.2", "7813.2", "7573.2", "3096", "11970", "1698", "2517", "8864", "1968", "2488", "3367", "3387", "9029", "7345", "2818", "7523", "3474", "4255", "5964", "4996", "2977", "6024", "99", "4646", "4916", "2948", "6314", "4625", "8693", "2028", "4867", "4707", "3917", "1419", "2338", "4724", "9286.9", "3165", "5347", "5888", "3867", "3612", "1307", "1499", "3412.9", "3447", "4437", "2338", "6275", "1949", "4367", "2898", "1869", "1869", "4317", "919", "2498", "1869", "1869", "919", "6236", "1598", "1598", "1598", "9748", "24134", "11965", "14523", "4812", "16900","8538"],
            "ShareASaleds": ["3", "1", "1", "1", "1", "1", "3", "1", "1", "1", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "2", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "6", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "0", "0", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "1", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "2", "1", "1", "1", "1", "1", "1", "1", "1", "1", "0", "1", "1", "1", "1", "1", "0", "0", "1", "1", "1", "1", "1", "2", "2", "1", "0", "1", "1", "2", "2", "3", "3", "3", "3", "2", "2", "2", "1", "3", "1", "2", "2", "0", "1", "2", "1", "1", "4", "3", "3", "3", "2", "1", "0", "1", "3", "2", "4", "2", "2", "3", "0", "4", "2", "2", "5", "1", "1", "4", "1", "1", "1", "4", "2", "5", "2", "3", "5", "2", "4", "3", "4", "4", "1", "5", "2", "5", "3", "5", "3", "2", "2", "1", "4", "1", "3", "1", "4", "8", "6", "5", "2", "5", "6", "0", "3", "11", "8", "2", "6", "7", "2", "6", "4", "6", "5", "1", "2", "5", "5", "3", "4", "7", "7", "2", "3", "3", "3", "4", "4", "6", "1", "3", "5", "3", "6", "8", "4", "8", "7", "5", "5", "7", "6", "7", "5", "8", "6", "3", "8", "2", "3", "6", "3", "3", "3", "2", "7", "6", "2", "6", "6", "3", "5", "4", "2", "5", "1", "4", "3", "2", "7", "4", "7", "2", "3", "3", "2", "1", "2", "4", "5", "4", "3", "5", "3", "4", "2", "1", "3", "2", "3", "2", "4", "1", "3", "2", "1", "1", "3", "1", "2", "1", "1", "1", "4", "2", "2", "2", "7", "12", "9", "7", "3", "11", "6"]
        }
    ],

}
let repeat = {
    code: 200,
    message: 'success',
    data: [
        {
            'time': ["2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["0", "0", "0", "2868", "0", "0", "0"],
            "AvantLinkzz": ["0", "0", "0", "2", "0", "0", "0"],
        },
        {
            'time': ["2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25", "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["1899", "308", "0", "1954", "1998", "0", "0", "2987", "0", "1419", "0", "1869", "0", "4317", "919", "1499", "0", "0", "0", "2838", "0", "0", "0", "0", "0", "0", "2868", "0", "0", "0"],
            "AvantLinkzz": ["1", "1", "0", "1", "1", "0", "0", "2", "0", "1", "0", "1", "0", "3", "1", "1", "0", "0", "0", "2", "0", "0", "0", "0", "0", "0", "2", "0", "0", "0"],
        },
        {
            'time': ["2022/6/4", "2022/6/5", "2022/6/6", "2022/6/7", "2022/6/8", "2022/6/9", "2022/6/10", "2022/6/11", "2022/6/12", "2022/6/13", "2022/6/14", "2022/6/15", "2022/6/16", "2022/6/17", "2022/6/18", "2022/6/19", "2022/6/20", "2022/6/21", "2022/6/22", "2022/6/23", "2022/6/24", "2022/6/25", "2022/6/26", "2022/6/27", "2022/6/28", "2022/6/29", "2022/6/30", "2022/7/1", "2022/7/2", "2022/7/3", "2022/7/4", "2022/7/5", "2022/7/6", "2022/7/7", "2022/7/8", "2022/7/9", "2022/7/10", "2022/7/11", "2022/7/12", "2022/7/13", "2022/7/14", "2022/7/15", "2022/7/16", "2022/7/17", "2022/7/18", "2022/7/19", "2022/7/20", "2022/7/21", "2022/7/22", "2022/7/23", "2022/7/24", "2022/7/25", "2022/7/26", "2022/7/27", "2022/7/28", "2022/7/29", "2022/7/30", "2022/7/31", "2022/8/1", "2022/8/2", "2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25", "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["0", "999", "1757", "1578", "1048", "0", "2398", "2148", "2028", "5095", "0", "1419", "2788", "3790", "0", "1449", "0", "1548", "1419", "0", "1998", "0", "0", "4026", "0", "0", "1869", "949", "40", "919", "1419", "2398", "0", "2818", "2848", "1747", "407", "3867", "129", "0", "5796", "0", "0", "3417", "0", "2917", "258", "1518", "0", "1419", "1419", "0", "0", "0", "1449", "3288", "1419", "0", "0", "0", "1899", "308", "0", "1954", "1998", "0", "0", "2987", "0", "1419", "0", "1869", "0", "4317", "919", "1499", "0", "0", "0", "2838", "0", "0", "0", "0", "0", "0", "2868", "0", "0", "0"],
            "AvantLinkzz": ["0", "1", "1", "1", "2", "0", "2", "2", "1", "3", "0", "1", "2", "3", "0", "1", "0", "2", "1", "0", "2", "0", "0", "2", "0", "0", "1", "1", "1", "1", "1", "2", "0", "2", "2", "3", "1", "2", "1", "0", "4", "0", "0", "2", "0", "3", "1", "2", "0", "1", "1", "0", "0", "0", "1", "2", "1", "0", "0", "0", "1", "1", "0", "1", "1", "0", "0", "2", "0", "1", "0", "1", "0", "3", "1", "1", "0", "0", "0", "2", "0", "0", "0", "0", "0", "0", "2", "0", "0", "0"],
        },
        {
            'time': ["2021/9/2", "2021/9/3", "2021/9/4", "2021/9/5", "2021/9/6", "2021/9/7", "2021/9/8", "2021/9/9", "2021/9/10", "2021/9/11", "2021/9/12", "2021/9/13", "2021/9/14", "2021/9/15", "2021/9/16", "2021/9/17", "2021/9/18", "2021/9/19", "2021/9/20", "2021/9/21", "2021/9/22", "2021/9/23", "2021/9/24", "2021/9/25", "2021/9/26", "2021/9/27", "2021/9/28", "2021/9/29", "2021/9/30", "2021/10/1", "2021/10/2", "2021/10/3", "2021/10/4", "2021/10/5", "2021/10/6", "2021/10/7", "2021/10/8", "2021/10/9", "2021/10/10", "2021/10/11", "2021/10/12", "2021/10/13", "2021/10/14", "2021/10/15", "2021/10/16", "2021/10/17", "2021/10/18", "2021/10/19", "2021/10/20", "2021/10/21", "2021/10/22", "2021/10/23", "2021/10/24", "2021/10/25", "2021/10/26", "2021/10/27", "2021/10/28", "2021/10/29", "2021/10/30", "2021/10/31", "2021/11/1", "2021/11/2", "2021/11/3", "2021/11/4", "2021/11/5", "2021/11/6", "2021/11/7", "2021/11/8", "2021/11/9", "2021/11/10", "2021/11/11", "2021/11/12", "2021/11/13", "2021/11/14", "2021/11/15", "2021/11/16", "2021/11/17", "2021/11/18", "2021/11/19", "2021/11/20", "2021/11/21", "2021/11/22", "2021/11/23", "2021/11/24", "2021/11/25", "2021/11/26", "2021/11/27", "2021/11/28", "2021/11/29", "2021/11/30", "2021/12/1", "2021/12/2", "2021/12/3", "2021/12/4", "2021/12/5", "2021/12/6", "2021/12/7", "2021/12/8", "2021/12/9", "2021/12/10", "2021/12/11", "2021/12/12", "2021/12/13", "2021/12/14", "2021/12/15", "2021/12/16", "2021/12/17", "2021/12/18", "2021/12/19", "2021/12/20", "2021/12/21", "2021/12/22", "2021/12/23", "2021/12/24", "2021/12/25", "2021/12/26", "2021/12/27", "2021/12/28", "2021/12/29", "2021/12/30", "2021/12/31", "2022/1/1", "2022/1/2", "2022/1/3", "2022/1/4", "2022/1/5", "2022/1/6", "2022/1/7", "2022/1/8", "2022/1/9", "2022/1/10", "2022/1/11", "2022/1/12", "2022/1/13", "2022/1/14", "2022/1/15", "2022/1/16", "2022/1/17", "2022/1/18", "2022/1/19", "2022/1/20", "2022/1/21", "2022/1/22", "2022/1/23", "2022/1/24", "2022/1/25", "2022/1/26", "2022/1/27", "2022/1/28", "2022/1/29", "2022/1/30", "2022/1/31", "2022/2/1", "2022/2/2", "2022/2/3", "2022/2/4", "2022/2/5", "2022/2/6", "2022/2/7", "2022/2/8", "2022/2/9", "2022/2/10", "2022/2/11", "2022/2/12", "2022/2/13", "2022/2/14", "2022/2/15", "2022/2/16", "2022/2/17", "2022/2/18", "2022/2/19", "2022/2/20", "2022/2/21", "2022/2/22", "2022/2/23", "2022/2/24", "2022/2/25", "2022/2/26", "2022/2/27", "2022/2/28", "2022/3/1", "2022/3/2", "2022/3/3", "2022/3/4", "2022/3/5", "2022/3/6", "2022/3/7", "2022/3/8", "2022/3/9", "2022/3/10", "2022/3/11", "2022/3/12", "2022/3/13", "2022/3/14", "2022/3/15", "2022/3/16", "2022/3/17", "2022/3/18", "2022/3/19", "2022/3/20", "2022/3/21", "2022/3/22", "2022/3/23", "2022/3/24", "2022/3/25", "2022/3/26", "2022/3/27", "2022/3/28", "2022/3/29", "2022/3/30", "2022/3/31", "2022/4/1", "2022/4/2", "2022/4/3", "2022/4/4", "2022/4/5", "2022/4/6", "2022/4/7", "2022/4/8", "2022/4/9", "2022/4/10", "2022/4/11", "2022/4/12", "2022/4/13", "2022/4/14", "2022/4/15", "2022/4/16", "2022/4/17", "2022/4/18", "2022/4/19", "2022/4/20", "2022/4/21", "2022/4/22", "2022/4/23", "2022/4/24", "2022/4/25", "2022/4/26", "2022/4/27", "2022/4/28", "2022/4/29", "2022/4/30", "2022/5/1", "2022/5/2", "2022/5/3", "2022/5/4", "2022/5/5", "2022/5/6", "2022/5/7", "2022/5/8", "2022/5/9", "2022/5/10", "2022/5/11", "2022/5/12", "2022/5/13", "2022/5/14", "2022/5/15", "2022/5/16", "2022/5/17", "2022/5/18", "2022/5/19", "2022/5/20", "2022/5/21", "2022/5/22", "2022/5/23", "2022/5/24", "2022/5/25", "2022/5/26", "2022/5/27", "2022/5/28", "2022/5/29", "2022/5/30", "2022/5/31", "2022/6/1", "2022/6/2", "2022/6/3", "2022/6/4", "2022/6/5", "2022/6/6", "2022/6/7", "2022/6/8", "2022/6/9", "2022/6/10", "2022/6/11", "2022/6/12", "2022/6/13", "2022/6/14", "2022/6/15", "2022/6/16", "2022/6/17", "2022/6/18", "2022/6/19", "2022/6/20", "2022/6/21", "2022/6/22", "2022/6/23", "2022/6/24", "2022/6/25", "2022/6/26", "2022/6/27", "2022/6/28", "2022/6/29", "2022/6/30", "2022/7/1", "2022/7/2", "2022/7/3", "2022/7/4", "2022/7/5", "2022/7/6", "2022/7/7", "2022/7/8", "2022/7/9", "2022/7/10", "2022/7/11", "2022/7/12", "2022/7/13", "2022/7/14", "2022/7/15", "2022/7/16", "2022/7/17", "2022/7/18", "2022/7/19", "2022/7/20", "2022/7/21", "2022/7/22", "2022/7/23", "2022/7/24", "2022/7/25", "2022/7/26", "2022/7/27", "2022/7/28", "2022/7/29", "2022/7/30", "2022/7/31", "2022/8/1", "2022/8/2", "2022/8/3", "2022/8/4", "2022/8/5", "2022/8/6", "2022/8/7", "2022/8/8", "2022/8/9", "2022/8/10", "2022/8/11", "2022/8/12", "2022/8/13", "2022/8/14", "2022/8/15", "2022/8/16", "2022/8/17", "2022/8/18", "2022/8/19", "2022/8/20", "2022/8/21", "2022/8/22", "2022/8/23", "2022/8/24", "2022/8/25", "2022/8/26", "2022/8/27", "2022/8/28", "2022/8/29", "2022/8/30", "2022/8/31", "2022/9/1"],
            "AvantLinkzxje": ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1119", "1799", "1399", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "99", "1048", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "899", "0", "0", "0", "1399", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1399", "0", "0", "3148", "2475", "0", "0", "0", "258", "1700", "2485", "1949", "0", "1398", "0", "0", "0", "0", "0", "0", "0", "949", "0", "0", "0", "152", "0", "0", "0", "0", "949", "1449", "0", "0", "1499", "0", "1169", "1449", "0", "1499", "0", "1499", "1449", "0", "0", "0", "129", "3798", "1449", "0", "649", "3398", "0", "0", "23", "152", "949", "0", "1899", "999", "0", "949", "1628", "0", "0", "3927", "0", "1499", "1499", "0", "0", "1449", "5528", "1548", "0", "2898", "2444", "129", "0", "1898", "1048", "1578", "0", "949", "2947", "0", "0", "4667", "2028", "129", "0", "1899", "1898", "1548", "0", "1449", "0", "0", "1419", "0", "0", "999", "1757", "1578", "1048", "0", "2398", "2148", "2028", "5095", "0", "1419", "2788", "3790", "0", "1449", "0", "1548", "1419", "0", "1998", "0", "0", "4026", "0", "0", "1869", "949", "40", "919", "1419", "2398", "0", "2818", "2848", "1747", "407", "3867", "129", "0", "5796", "0", "0", "3417", "0", "2917", "258", "1518", "0", "1419", "1419", "0", "0", "0", "1449", "3288", "1419", "0", "0", "0", "1899", "308", "0", "1954", "1998", "0", "0", "2987", "0", "1419", "0", "1869", "0", "4317", "919", "1499", "0", "0", "0", "2838", "0", "0", "0", "0", "0", "0", "2868", "0", "0", "0"],
            "AvantLinkzz": ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1", "1", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "1", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "0", "0", "0", "1", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "1", "0", "0", "2", "2", "0", "0", "0", "1", "2", "1", "1", "0", "1", "0", "0", "0", "0", "0", "0", "0", "1", "0", "0", "0", "1", "0", "0", "0", "0", "1", "1", "0", "0", "1", "0", "1", "1", "0", "1", "0", "1", "1", "0", "0", "0", "1", "2", "1", "0", "1", "2", "0", "0", "1", "1", "1", "0", "1", "1", "0", "1", "2", "0", "0", "2", "0", "1", "1", "0", "0", "1", "3", "2", "0", "2", "2", "1", "0", "2", "1", "2", "0", "1", "3", "0", "0", "4", "1", "1", "0", "1", "2", "2", "0", "1", "0", "0", "1", "0", "0", "1", "1", "1", "2", "0", "2", "2", "1", "3", "0", "1", "2", "3", "0", "1", "0", "2", "1", "0", "2", "0", "0", "2", "0", "0", "1", "1", "1", "1", "1", "2", "0", "2", "2", "3", "1", "2", "1", "0", "4", "0", "0", "2", "0", "3", "1", "2", "0", "1", "1", "0", "0", "0", "1", "2", "1", "0", "0", "0", "1", "1", "0", "1", "1", "0", "0", "2", "0", "1", "0", "1", "0", "3", "1", "1", "0", "0", "0", "2", "0", "0", "0", "0", "0", "0", "2", "0", "0", "0"],
        },
    ]
}
let duplicate = {
    code: 200,
    message: 'success',
    "avantLink": [
        {
            "time": "过去7天",
            "distribution": "6344", // 总分销金额
            "repeats": "2868", // 重复金额
            "proportionAmount": "45.21", // 重复金额占比    
            "distributionUnm": "6", // 总分销订单数
            "repeatsNum": "2", // 重复订单数 
            "OrderAmount": "33.33", // 重复订单占比
        },
        {
            "time": "过去30天",
            "distribution": "50274.8", // 总分销金额
            "repeats": "25874", // 重复金额
            "proportionAmount": "51.47", // 重复金额占比
            "distributionUnm": "39", // 总分销订单数
            "repeatsNum": "18", // 重复订单数
            "OrderAmount": "46.15", // 重复订单占比
        },
        {
            "time": "过去90天",
            "distribution": "219183.3", // 总分销金额
            "repeats": "106010.9", // 重复金额
            "proportionAmount": "48.37", // 重复金额占比
            "distributionUnm": "174", // 总分销订单数
            "repeatsNum": "83", // 重复订单数
            "OrderAmount": "47.70", // 重复订单占比
        },
        {
            "time": "过去1年",
            "distribution": "629101.89", // 总分销金额
            "repeats": "211827.6", // 重复金额
            "proportionAmount": "33.67", // 重复金额占比
            "distributionUnm": "521", // 总分销订单数
            "repeatsNum": "169", // 重复订单数
            "OrderAmount": "32.44", // 重复订单占比
        },
    ],
    "ShareAsale": [

        {
            "time": "过去7天",
            "distribution": "10650.9", // 总分销金额
            "repeats": "2868", // 重复金额
            "proportionAmount": "26.93", // 重复金额占比    
            "distributionUnm": "9", // 总分销订单数
            "repeatsNum": "2", // 重复订单数 
            "OrderAmount": "22.22", // 重复订单占比
        },
        {
            "time": "过去30天",
            "distribution": "73351.8", // 总分销金额
            "repeats": "25874", // 重复金额
            "proportionAmount": "35.27", // 重复金额占比
            "distributionUnm": "57", // 总分销订单数
            "repeatsNum": "18", // 重复订单数
            "OrderAmount": "31.58", // 重复订单占比
        },
        {
            "time": "过去90天",
            "distribution": "399950", // 总分销金额
            "repeats": "106010.9", // 重复金额
            "proportionAmount": "26.51", // 重复金额占比
            "distributionUnm": "315", // 总分销订单数
            "repeatsNum": "83", // 重复订单数
            "OrderAmount": "26.35", // 重复订单占比
        },
        {
            "time": "过去1年",
            "distribution": "1014240.43", // 总分销金额
            "repeats": "211827.6", // 重复金额
            "proportionAmount": "20.89", // 重复金额占比
            "distributionUnm": "791", // 总分销订单数
            "repeatsNum": "169", // 重复订单数
            "OrderAmount": "21.37", // 重复订单占比
        },

    ]
}
let comprehensive = {
    code: 200,
    message: 'success',
    'time1': [
        {
            "value": "5475.9",
            "name": "Content",
        },
        {
            "value": "949",
            "name": "Coupon",
        },
        {
            "value": "3976",
            "name": "Cash-Back",
        },
        {
            "value": "4306",
            "name": "Social Media",
        },
        {
            "value": "2967",
            "name": "Sub-Aff",
        },
    ],
    'time2': [
        {
            "value": "22635.8",
            "name": "Content",
        },
        {
            "value": "10653",
            "name": "Coupon",
        },
        {
            "value": "21442",
            "name": "Cash-Back",
        },
        {
            "value": "44370",
            "name": "Social Media",
        },
        {
            "value": "24200.8",
            "name": "Sub-Aff",
        },
    ],
    'time3': [
        {
            "value": "184837.1",
            "name": "Content",
        },
        {
            "value": "58103",
            "name": "Coupon",
        },
        {
            "value": "131755.3",
            "name": "Cash-Back",
        },
        {
            "value": "121403",
            "name": "Social Media",
        },
        {
            "value": "134452.8",
            "name": "Sub-Aff",
        },
    ],
    'time4': [
        {
            "value": "438012.88",
            "name": "Content",
        },
        {
            "value": "148714.3",
            "name": "Coupon",
        },
        {
            "value": "313272.09",
            "name": "Cash-Back",
        },
        {
            "value": "180620.3",
            "name": "Social Media",
        },
        {
            "value": "267927.5",
            "name": "Sub-Aff",
        },
    ]

}
let domnebhts = {
    code: 200,
    message: 'success',
    'time1': [
        {
            "value": "5",
            "name": "Content",
        },
        {
            "value": "1",
            "name": "Coupon",
        },
        {
            "value": "4",
            "name": "Cash-Back",
        },
        {
            "value": "4",
            "name": "Social Media",
        },
        {
            "value": "2",
            "name": "Sub-Aff",
        },
    ],
    'time2': [
        {
            "value": "20",
            "name": "Content",
        },
        {
            "value": "7",
            "name": "Coupon",
        },
        {
            "value": "18",
            "name": "Cash-Back",
        },
        {
            "value": "32",
            "name": "Social Media",
        },
        {
            "value": "18",
            "name": "Sub-Aff",
        },
    ],
    'time3': [
        {
            "value": "149",
            "name": "Content",
        },
        {
            "value": "47",
            "name": "Coupon",
        },
        {
            "value": "107",
            "name": "Cash-Back",
        },
        {
            "value": "87",
            "name": "Social Media",
        },
        {
            "value": "107",
            "name": "Sub-Aff",
        },
    ],
    'time4': [
        {
            "value": "345",
            "name": "Content",
        },
        {
            "value": "114",
            "name": "Coupon",
        },
        {
            "value": "266",
            "name": "Cash-Back",
        },
        {
            "value": "133",
            "name": "Social Media",
        },
        {
            "value": "214",
            "name": "Sub-Aff",
        },
    ]
}

let jelist = {
    code: 200,
    message: 'success',
    'time1': [

        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "4207",
            "oderunm": "3",
            "type": "Social Media",
            "pt": "ShareASale"
        },
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "hhttp://www.joinhoney.com/partners",
            "je": "3976",
            "oderunm": "4",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "learnmetrics.com/",
            "je": "2498",
            "oderunm": "2",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "1548",
            "oderunm": "1",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Powered Portable Solar',
            "id": "525050096",
            "url": "poweredportablesolar.com",
            "je": "1449",
            "oderunm": "1",
            "type": "Content",
            "pt": "ShareASale"
        },

    ],
    "time2": [
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "30812",
            "oderunm": "22",
            "type": "Social Media",
            "pt": "ShareASale"
        },
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "hhttp://www.joinhoney.com/partners",
            "je": "15187",
            "oderunm": "13",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'FlexOffers.com',
            "id": "51328936",
            "url": "http://www.flexoffers.com",
            "je": "14247",
            "oderunm": "10",
            "type": "Sub-Aff",
            "pt": "AvantLink"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "learnmetrics.com/",
            "je": "8944",
            "oderunm": "6",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "7752",
            "oderunm": "6",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
    ],
     "time3": [
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "86041",
            "oderunm": "60",
            "type": "Social Media",
            "pt": "ShareASale"
        },
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "hhttp://www.joinhoney.com/partners",
            "je": "82667",
            "oderunm": "68",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "54103",
            "oderunm": "42",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Kuang Zhaojun',
            "id": "529543926",
            "url": "bgreviewer.com/",
            "je": "50762",
            "oderunm": "46",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "learnmetrics.com/",
            "je": "42068",
            "oderunm": "30",
            "type": "Content",
            "pt": "ShareASale"
        },
    ],
    "time4": [
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "http://www.joinhoney.com/partners",
            "je": "204642",
            "oderunm": "172",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'Kuang Zhaojun',
            "id": "529543926",
            "url": "bgreviewer.com/",
            "je": "113096",
            "oderunm": "100",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'FlexOffers.com',
            "id": "51328936",
            "url": "dhttp://www.flexoffers.com",
            "je": "94186",
            "oderunm": "71",
            "type": "Sub-Aff",
            "pt": "AvantLink"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "91927",
            "oderunm": "69",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "87688",
            "oderunm": "63",
            "type": "Social Media",
            "pt": "ShareASale"
        },
    ]
}




let tablist = {
    code: 200,
    message: 'success',
    'time1': [
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "http://www.joinhoney.com/partners",
            "je": "3976",
            "oderunm": "4",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "4207",
            "oderunm": "3",
            "type": "Social Media",
            "pt": "ShareASale"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "learnmetrics.com/",
            "je": "2498",
            "oderunm": "2",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "1548",
            "oderunm": "1",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Powered Portable Solar',
            "id": "525050096",
            "url": "poweredportablesolar.com",
            "je": "1449",
            "oderunm": "1",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'FlexOffers.com',
            "id": "51328936",
            "url": "http://www.flexoffers.com",
            "je": "1419",
            "oderunm": "1",
            "type": "Sub-Aff",
            "pt": "AvantLink"
        },
        {
            "name": 'Savinggain',
            "id": "52228936",
            "url": "https://www.savinggain.com/",
            "je": "949",
            "oderunm": "1",
            "type": "Coupon",
            "pt": "AvantLink"
        },
        {
            "name": "Kuang Zhaojun",
            "id": "529543926",
            "url": "bgreviewer.com/",
            "je": "29",
            "oderunm": "1",
            "type": "Content",
            "pt": "ShareASale"
        },

    ],
    'time2': [
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "30812",
            "oderunm": "22",
            "type": "Social Media",
            "pt": "ShareASale"
        },
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "hobotech.tv",
            "je": "15187",
            "oderunm": "13",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'FlexOffers.com',
            "id": "51328936",
            "url": "http://www.flexoffers.com",
            "je": "14247",
            "oderunm": "10",
            "type": "Sub-Aff",
            "pt": "AvantLink"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "http://www.flexoffers.com",
            "je": "8944",
            "oderunm": "6",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "7752",
            "oderunm": "6",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
    ],
    'time3': [
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349756",
            "url": "http://www.joinhoney.com/partners",
            "je": "82667",
            "oderunm": "68",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "86041",
            "oderunm": "60",
            "type": "Social Media",
            "pt": "ShareASale"
        },
      
        {
            "name": 'Kuang Zhaojun',
            "id": "529543926",
            "url": "bgreviewer.com/",
            "je": "50762",
            "oderunm": "46",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "bgreviewer.com/",
            "je": "54103",
            "oderunm": "42",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Moving Data Systems d.o.o',
            "id": "516050846",
            "url": "learnmetrics.com/",
            "je": "42068",
            "oderunm": "30",
            "type": "Content",
            "pt": "ShareASale"
        },
    ],
    'time4': [
        {
            "name": 'Honey (acquired by PayPal)',
            "id": "51349755",
            "url": "http://www.joinhoney.com/partners",
            "je": "204642",
            "oderunm": "172",
            "type": "Cash-Back",
            "pt": "AvantLink"
        },
        {
            "name": 'Kuang Zhaojun',
            "id": "529543926",
            "url": "bgreviewer.com/",
            "je": "113096",
            "oderunm": "100",
            "type": "Content",
            "pt": "ShareASale"
        },
        {
            "name": 'FlexOffers.com',
            "id": "51328936",
            "url": "http://www.flexoffers.com",
            "je": "94186",
            "oderunm": "71",
            "type": "Sub-Aff",
            "pt": "AvantLink"
        },
        {
            "name": 'digidip GmbH',
            "id": "57457886",
            "url": "digidip.net",
            "je": "91927",
            "oderunm": "69",
            "type": "Sub-Aff",
            "pt": "ShareASale"
        },
        {
            "name": 'Tom Kampert',
            "id": "523783226",
            "url": "hobotech.tv",
            "je": "87688",
            "oderunm": "63",
            "type": "Social Media",
            "pt": "ShareASale"
        },
    ],
}
export default {
    'get|/getUserList': userList,
    'post|/postUserList': hits,
    'post|/bullList': bulletin,
    'post|/repeatList': repeat,
    'post|/duplicatelist': duplicate,
    'post|/comprehensivelist': comprehensive,
    'post|/domnebhtslist': domnebhts,
    'post|/tabList': tablist,
    'post|/jelist': jelist,
    // 'post/'
}
